import React from 'react';
import { OfferRequisition } from '../../../../../../entities/v1/applicant_tracking/OfferRequisition';
import { CardEntry } from '../../../../../../components/ApplicantTracking/Requisition/CardEntry';
import RequisitionCard from '../../../../../../components/ApplicantTracking/Requisition/RequisitionCard';
import styles from '../styles.module.scss';

interface PropTypes {
  offerRequisition: OfferRequisition;
}

export default function OfferRequisitionInfoCard(props: PropTypes) {
  return (
    <RequisitionCard
      title={'Requisition'}
      className={styles['requisition-info-card']}
      gap='2h'
    >
      <CardEntry
        label={'Requisition ID'}
        value={props.offerRequisition.uid}
        className={'mt-2'}
        copy={true}
      />
      <CardEntry
        label={'Requisition Owner'}
        value={props.offerRequisition.ownerUser.name}
      />
      <hr className={'my-1'} />
      <CardEntry
        label='Candidate'
        value={props.offerRequisition.signableOffer.application.candidate.name}
      />
      <CardEntry
        label='Job Role'
        value={props.offerRequisition.signableOffer.application.job.name}
      />
    </RequisitionCard>
  );
}
